import { render, staticRenderFns } from "./LgFinderPageEmpresa.vue?vue&type=template&id=5359508b"
import script from "./LgFinderPageEmpresa.vue?vue&type=script&lang=js"
export * from "./LgFinderPageEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports